import { render, staticRenderFns } from "./LHRPersegmenSection.vue?vue&type=template&id=6ca88ab5&scoped=true"
import script from "./LHRPersegmenSection.vue?vue&type=script&lang=js"
export * from "./LHRPersegmenSection.vue?vue&type=script&lang=js"
import style0 from "./LHRPersegmenSection.vue?vue&type=style&index=0&id=6ca88ab5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca88ab5",
  null
  
)

export default component.exports